import React, { useMemo } from 'react'

import { Grid } from '@barracuda-internal/bds-core'

import styles from 'components/pages/overview/dashboard/dashboardStyles'
import TableWithDropdown from 'components/libs/tableWithDropdown/TableWithDropdown'
import { DisplayType, getTableWithDropdownConfig } from 'components/libs/tableWithDropdown/config'
import { StatType } from 'types/stats'
import { useInboundTopBlockedLogic, UseInboundTopBlockedLogicProps } from './useInboundTopBlockedLogic'

const InboundTopBlocked: React.FC<UseInboundTopBlockedLogicProps> = (props: UseInboundTopBlockedLogicProps) => {
  const classes = styles()
  const [state, eventHandlers] = useInboundTopBlockedLogic(props)

  return useMemo(() => {
    const config = getTableWithDropdownConfig(
      DisplayType.inbound,
      state.selectedFilter === StatType.SENDERS ? StatType.SENDERS : StatType.RECIPIENTS
    )
    return (
      <Grid className={classes.tableWrapper} item data-testid="container">
        {config && (
          <TableWithDropdown
            config={config}
            data={state.inboundTopBlockedStats?.results}
            onSelect={eventHandlers.onSelectFilter}
            selectedValue={state.selectedFilter}
            inProgress={state.inboundTopBlockedStatsInProgress}
            rankColumn
          />
        )}
      </Grid>
    )
  }, [state, classes, eventHandlers])
}

export default InboundTopBlocked
